export const createURLSearchParams = (queries: object): string => {
  const searchParams = new URLSearchParams();

  Object.entries(queries).forEach(([key, value]) => {
    searchParams.append(key, value);
  });

  return searchParams.toString();
};
